import { RefObject } from "react";

import { Typography } from "@mui/material";
import moment from "moment";
import { Link, useParams } from "react-router-dom";

import noAvatarImage from "../../../../imagenes/no_avatar.svg";
import { TProgressSummary } from "../../hooks/useMyCourseInstructor";
import { TRequestMoneyDialogRef } from "./RequestMoneyDialog";

export type TLearningSummaryItemProps = {
	learningSummary: TProgressSummary;
	requestMoneyDialogRef: RefObject<TRequestMoneyDialogRef | null>;
};

export function LearningSummaryItem({
	learningSummary,
	requestMoneyDialogRef,
}: TLearningSummaryItemProps) {
	const { slug } = useParams();

	const student = learningSummary.student;
	const studentName = `${student.firstName} ${student.lastName}`.trim();

	const onClickOpenRequestMoney = () => {
		requestMoneyDialogRef.current?.open(
			studentName,
			learningSummary.studentId,
			learningSummary.id,
		);
	};

	let progressText = "";
	if (learningSummary.passedCount === 1) {
		progressText = `1 class out of ${learningSummary.bookings.length}`;
	} else {
		progressText = `${learningSummary.passedCount} classes out of ${learningSummary.bookings.length}`;
	}
	const airHoursText = `${learningSummary.airHours.toFixed(1)} hrs in Flight`;
	const simulatorHoursText = `${learningSummary.simulatorHours.toFixed(1)} hrs in Sim`;
	const milesFlownText = `${learningSummary.milesFlown} miles Flown`;
	let studentBinderLink = `/teaching/${slug}/${learningSummary.studentId}`;
	if (learningSummary.lastAppointment) {
		studentBinderLink = `/teaching/${slug}/${learningSummary.studentId}?class=${learningSummary.lastAppointment.id}`;
	}

	return (
		<div className="learning-summary-item-container item-separator-big">
			<img
				src={
					student.profile?.thumbnail || student.profile?.url || noAvatarImage
				}
				className="avatar"
			/>
			<div style={{ flex: 1 }}>
				<Typography
					component="a"
					href={`/profile/${student.profile?.profileSlug}`}
					className="big-text bold black-text underline-on-hover-link">
					{studentName}
				</Typography>
				<div
					className="item-separator-small"
					style={{ display: "flex", flexDirection: "column", rowGap: "8px" }}>
					{learningSummary.nextAppointment && (
						<div className="summary-info-container">
							<Typography className="normal-text">
								<span className="bold">Next class:</span>
								{` ${learningSummary.nextAppointment.lesson.title}`}
							</Typography>
							<Typography className="normal-text">
								<span className="bold">Appointment Date:</span>
								{` ${moment(learningSummary.nextAppointment.startTime).format("dddd, D MMM YYYY, HH:mm")}`}
							</Typography>
						</div>
					)}
					<Typography className="normal-text bold">Progress:</Typography>
					<div className="summary-info-container">
						<Typography className="normal-text">{progressText}</Typography>
						<Typography className="normal-text">{airHoursText}</Typography>
						<Typography className="normal-text">
							{simulatorHoursText}
						</Typography>
						<Typography className="normal-text">{milesFlownText}</Typography>
					</div>
					<div className="summary-info-container">
						<Typography
							onClick={onClickOpenRequestMoney}
							className="normal-text bold gray-text underline-link">
							Request money
						</Typography>
						<div style={{ flex: 1 }} />
						<Link to={studentBinderLink} className="blue-text underline-link">
							<Typography className="normal-text bold">
								Student Binder
							</Typography>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
}
